module.exports = __webpack_public_path__ + "img/14.42ade42f.jpeg";